import { z } from 'zod';
export function strictObjectNullableProps(schema) {
    const entries = Object.entries(schema.shape);
    return z.strictObject(entries.reduce((acc, [key, value]) => {
        acc[key] = value.nullable();
        return acc;
    }, {}));
}
export function zEnumFromArray(data) {
    return z.enum(data);
}
